import React, { forwardRef, useState, useEffect, SyntheticEvent } from "react";
import {useMediaQuery, useTheme, Card, Grid, Button, Divider, MenuItem, TextField, InputLabel, CardContent, FormControl, Select, Typography, Box, CardActions, Checkbox, FormControlLabel, Switch } from '@mui/material';
import axios from 'axios';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import Title from '../../../components/Title';
import { Office } from '../../../models/office';
import { Collect } from '../../../models/collect';
import { Expense } from '../../../models/expense';
import { Type_Operation } from '../../../models/type_operation';
import CollectDetails from './modal/CollectDetail';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import CleaningServicesRoundedIcon from '@mui/icons-material/CleaningServicesRounded';
import "react-datepicker/dist/react-datepicker.css";
import { useSelection } from '../../../components/context/SelectionContext';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import CollectBox from "./modal/CollectBox";
import HeaderResponsive from "../../../components/layouts/HeaderResponsive";
import { nowOperationalDateTimeString } from "../../../utils/operationalDateTime";
import PermissionButton from "../../../components/common/PermissionButton";
import { useResourcePermissions } from "../../../hooks/useResourcePermissions";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';

type CajaMode = 'cobro' | 'seguro';

const CAJA_SEGURO_TYPE_NAME = 'Caja Seguro';
const CAJA_COBRO_TYPE_NAME = 'Caja Cobro';
const SEGUROS_TYPE_EXPENSE_NAME = 'SEGUROS';
const OFICINA_TYPE_EXPENSE_NAME = 'Gastos Oficina';

const getBoxByMode = (collect: Collect | null | undefined, mode: CajaMode) => {
  if (!collect?.box?.length) return null;
  const typeName = mode === 'seguro' ? CAJA_SEGURO_TYPE_NAME : CAJA_COBRO_TYPE_NAME;
  return collect.box.find((b: any) => b.typeBox?.name === typeName) || (mode === 'cobro' ? collect.box[0] : null);
};

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const GastosAdd: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { canView: canViewMainCashMovements } = useResourcePermissions('/administrar/cajas/add');
  const { canAdjustBox, canRegisterExpenses, canManageInsuranceBox } = useResourcePermissions('/prestamos/gastos/add');
  const [cajaMode, setCajaMode] = useState<CajaMode>('cobro');
  const [insuranceTypeExpenseId, setInsuranceTypeExpenseId] = useState<number | null>(null);
  const [box_id, setBox_id] = useState('');
  const [balance, setBalance] = useState('');
  const [collectsOffice, setCollectsOffice] = useState<Collect[]>([]);
  const [box, setBox] = useState<any[]>([]);
  const [boxOfficeId, setBoxOfficeId] = useState<number | null>(null);
  const [affectMainBox, setAffectMainBox] = useState(false);
  const [tipogasto, setTipoGasto] = useState('');
  const [value, setValue] = useState('');
  const [description, setDescripcion] = useState('');
  const navigate = useNavigate();
  const [expensesid, setExpensesId] = useState<number | null>(null);
  const [operation, setOperation] = useState<Type_Operation[]>([]);
  const [offices, setOffices] = useState<Office[]>([]);
  const [date_movement, setDate_movement] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenBox, setModalOpenBox] = useState(false);
  const [selectedCollect, setSelectedCollect] = useState<Collect | null>(null);
  const [expenses, setExpenses] = useState<Expense[]>([]);
  const [expensesBox, setExpensesBox] = useState<Expense[]>([]);
  const [collectExpenses, setCollectExpenses] = useState<{ [key: number]: { [key: number]: { value: number, box_id: number, type_operation_id: number } } }>({});

  const [collectCheckbox, setCollectCheckbox] = useState<{ [key: number]: boolean }>({});
  const { office_id, setOffice_id, collect_id, setCollect_id, user_id, setUser_id } = useSelection();
  const [selectedExpensesByCollect, setSelectedExpensesByCollect] = useState<{ [key: number]: number[] }>({});

  // Función para actualizar los gastos seleccionados por cobro
  const handleSelectedExpensesChange = (collectId: number, expenseIds: number[]) => {
    setSelectedExpensesByCollect((prev) => ({
      ...prev,
      [collectId]: expenseIds,
    }));
  };
  const handleOpenModal = (collect: Collect) => {
    if (collectCheckbox[collect.id]) {
      setSelectedCollect(collect);
      setModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCollect(null);
  };
  const OpenModalBox = (collect: Collect) => {
    if (collectCheckbox[collect.id]) {
      setSelectedCollect(collect);
      setModalOpenBox(true);
    }
  };
  const CloseModalBox = () => {
    setModalOpenBox(false);
    setSelectedCollect(null);
  };

  // Función para actualizar el valor de un gasto en un cobro específico
  const handleSetExpenseValue = (collectId: number, expenseId: number, value: number, boxId: number, typeOperationId: number) => {
    setCollectExpenses((prev) => ({
      ...prev,
      [collectId]: {
        ...prev[collectId],
        [expenseId]: {
          value,
          box_id: boxId,
          type_operation_id: typeOperationId,
        },
      },
    }));
  };
  // Función para actualizar el valor de un gasto en un cobro específico (para el modal CollectBox)
  const SetExpenseValueBox = (collectId: number, expenseId: number, value: number, boxId: number, typeOperationId: number) => {
    setCollectExpenses((prev) => ({
      ...prev,
      [collectId]: {
        ...prev[collectId],
        [expenseId]: {
          value,
          box_id: boxId,
          type_operation_id: typeOperationId
        },
      },
    }));
  };

  const handleClearExpenses = (collectId: number) => {
    setCollectExpenses(prev => ({
      ...prev,
      [collectId]: {}
    }));
    setCollectCheckbox(prev => ({
      ...prev,
      [collectId]: false
    }));
  };

  const handleCheckboxChange = (collectId: number) => {
    setCollectCheckbox(prev => {
      const newState = !prev[collectId];
      if (!newState) {
        handleClearExpenses(collectId);
      }
      return {
        ...prev,
        [collectId]: newState
      };
    });
  };
  const handleToggleAllCollects = () => {
    const allChecked = Object.values(collectCheckbox).every((isChecked) => isChecked);
    const newCollectCheckbox = { ...collectCheckbox };
    collectsOffice.forEach((collect) => {
      newCollectCheckbox[collect.id] = !allChecked;
    });
    setCollectCheckbox(newCollectCheckbox);
    if (allChecked) {
      setCollectExpenses({});
    }
  };
  const validateTotal = () => {
    const totalCollectExpenses = Object.values(collectExpenses).reduce((acc, expenses) => {
      return acc + Object.values(expenses).reduce((sum, expense) => sum + expense.value, 0);
    }, 0);

    return totalCollectExpenses === parseInt(value);
  };

  const submit = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (!office_id || !value || !collectExpenses) {
      showAlert('Por favor, complete todos los campos obligatorios!', 'warning');
      return;
    }
    if (!validateTotal()) {
      showAlert('La suma de los valores de los cobros debe ser igual al valor total!', 'warning');
      return;
    }
    showLoading();
    const filteredCollectExpenses = Object.fromEntries(
      Object.entries(collectExpenses)
        .map(([collectId, expenses]) => {
          const normalizedExpenses = Object.fromEntries(
            Object.entries(expenses)
              .filter(([, expense]) => expense.value > 0)
              .map(([expenseId, expense]) => [
                expenseId,
                {
                  value: expense.value,
                  box_origin_id: expense.box_id,
                  type_operation_id: expense.type_operation_id,
                },
              ])
          );

          if (Object.keys(normalizedExpenses).length === 0) {
            return null;
          }

          const expensesValues = Object.values(normalizedExpenses) as Array<{
            box_origin_id: number;
          }>;
          const boxOriginId = expensesValues[0]?.box_origin_id;

          if (boxOriginId === undefined || boxOriginId === null) {
            return null;
          }

          return [boxOriginId.toString(), normalizedExpenses];
        })
        .filter((entry): entry is [string, Record<string, { value: number; box_origin_id: number; type_operation_id: number }>] => entry !== null)
    );

    const expenseDate = date_movement
      ? `${String(date_movement).slice(0, 10)} ${nowOperationalDateTimeString().slice(11)}`
      : nowOperationalDateTimeString();
    const formData = {
      date: expenseDate,
      description: description,
      box_destination_id: affectMainBox ? boxOfficeId : null,
      value: parseInt(value),
      collect_expenses: filteredCollectExpenses,
      user_id: user_id,
    };
    // //console.log("formData", formData);
    try {
      // const response = await axios.post('/expensescollect', formData);
      const response = await axios.post('/boxmovementcollect', formData);
      showAlert('Se ha realizado el registro exitosamente!', 'success');
      await new Promise((resolve) => setTimeout(resolve, 1000));
      navigate('/prestamos/gastos/list');
    } catch (error) {
      showAlert('Error fetching data Expense', 'error');
    } finally {
      hideLoading();
    }
  };

  const fetchBalance = async (officeId: string) => {
    try {
      const { data } = await axios.get(`/boxoffice/${officeId}`);
      setBalance(data.data[0].balance);
      setBoxOfficeId(data.data[0].id);
    } catch (error) {
      showAlert('Error fetching balance!', 'error');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      showLoading();
      try {
        const [{ data: userData }, { data: officesData }, { data: operationData }] = await Promise.all([
          axios.get('user'),
          axios.get('offices'),
          axios.get('typeoperation'),
        ]);
        setUser_id(userData.data.id);
        setOffices(officesData.data);
        const filteredOperations = operationData.data.filter((op: Type_Operation) => op.id === 2);
        setOperation(filteredOperations);
        await new Promise((resolve) => setTimeout(resolve, 2000));
      } catch (error) {
        showAlert('Error fetching data1!', 'error');
      } finally {
        hideLoading();
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (office_id) {
        showLoading();
        try {
          const [{ data: boxData }, { data: collectsData }] = await Promise.all([
            axios.get(`/boxoffice/${office_id}`),
            axios.get(`collectsoffice/${office_id}`),
          ]);

          if (boxData.data.length > 0) {
            setBox(boxData.data[0]);
            setBox_id(boxData.data[0].id);
            await fetchBalance(office_id);
          } else {
            showAlert('La oficina seleccionada no tiene saldo en caja disponible!', 'warning');
          }
          setCollectsOffice(collectsData);
          if (collectsData.length === 0) {
            showAlert('No existen cobros asociados a la oficina!', 'warning');
          }
        } catch (error) {
          showAlert('Error fetching data2!', 'error');
        } finally {
          hideLoading();
        }
      }
    };
    fetchData();
  }, [office_id]);

  // Resuelve el id de la categoría "SEGUROS" (puede variar por cliente, no se hardcodea).
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('typeexpense');
        const seguros = (data?.data || []).find(
          (te: { id: number; name: string }) => te.name === SEGUROS_TYPE_EXPENSE_NAME
        );
        setInsuranceTypeExpenseId(seguros ? seguros.id : null);
      } catch (error) {
        // Silencioso: si no existe la categoría, el toggle de Caja Seguro simplemente no tendrá conceptos.
      }
    })();
  }, []);

  useEffect(() => {
    if (cajaMode === 'seguro' && !insuranceTypeExpenseId) {
      setExpenses([]);
      return;
    }
    const typeExpenseId = cajaMode === 'seguro' ? insuranceTypeExpenseId : 3;
    (async () => {
      try {
        const { data } = await axios.post('getexpensesbytypeops', { type_expense_id: typeExpenseId, type_operation_id: 2 });
        setExpenses(data.data);
        if (cajaMode === 'cobro') {
          const { data: dataBox } = await axios.get(`expensetypebox/3`);
          setExpensesBox(dataBox.data);
        } else {
          setExpensesBox([]);
        }
        setExpensesId(null);
        setTipoGasto('');
      } catch (error) {
        showAlert('Error fetching Operation!', 'error');
      }
    })();
  }, [cajaMode, insuranceTypeExpenseId]);

  return (
    <HeaderResponsive>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Title>Registrar Gastos Administrativos</Title>
        <Box display="flex" gap={1}>
          <Button
            variant="outlined"
            component={NavLink}
            to="/prestamos/gastos/list"
            size="small"
          >
            Ver movimientos
          </Button>
          <PermissionButton
            allowed={canViewMainCashMovements}
            deniedTooltip="Sin permiso para ver caja principal"
            tooltip="Caja Principal"
            variant="contained"
            startIcon={isMobile ? null : <AddBusinessIcon />}
            component={NavLink}
            to="/administrar/cajas/add"
            size="small"
          >
            {isMobile ? <AddBusinessIcon /> : 'Caja Prinicpal'}
          </PermissionButton>
        </Box>
      </Box>
      {canManageInsuranceBox ? (
        <Box display="flex" justifyContent="flex-end" mb={1}>
          <ToggleButtonGroup
            size="small"
            exclusive
            value={cajaMode}
            onChange={(_, newMode) => {
              if (newMode) setCajaMode(newMode);
            }}
          >
            <ToggleButton value="cobro">
              <PointOfSaleRoundedIcon fontSize="small" sx={{ mr: 0.5 }} /> Caja Cobro
            </ToggleButton>
            <ToggleButton value="seguro">
              <HealthAndSafetyIcon fontSize="small" sx={{ mr: 0.5 }} /> Caja Seguro
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      ) : null}
      <Card>
        <Divider sx={{ margin: 0 }} />
        <form onSubmit={(e) => e.preventDefault()}>
          <CardContent sx={{maxHeight: 600,  overflow: 'scroll'}}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <FormControl fullWidth>
                  <InputLabel id='Seleccionar Oficina '>Seleccionar Oficina</InputLabel>
                  {offices && offices.length > 0 ? (
                    <Select
                      label='Seleccionar Oficina'
                      value={office_id}
                      id='Seleccionar Oficina'
                      labelId='Seleccionar Oficina'
                      onChange={(event) => setOffice_id(event.target.value)}
                      size="small"
                      required
                    >
                      {offices.map((office: Office) => (
                        <MenuItem key={office.id} value={office.id}>
                          {office.name}
                        </MenuItem>
                      ))}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{ textAlign: 'right' }}>
                <TextField fullWidth label='Saldo Disponible Oficina' size="small" value={balance || 0} />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField fullWidth label='Valor' placeholder='1000' size="small" type='number' required onChange={(event) => setValue(event.target.value)} inputProps={{ maxLength: 20, min: 0 }} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField fullWidth label='Descripción' maxRows={3} size="small" placeholder='Describa el motivo del gasto' onChange={(event) => setDescripcion(event.target.value)} inputProps={{ maxLength: 100 }} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={affectMainBox}
                      onChange={(event) => setAffectMainBox(event.target.checked)}
                      disabled={!boxOfficeId}
                    />
                  }
                  label="Afectar caja principal"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Object.values(collectCheckbox).every((isChecked) => isChecked)}
                      indeterminate={
                        !Object.values(collectCheckbox).every((isChecked) => isChecked) &&
                        Object.values(collectCheckbox).some((isChecked) => isChecked)
                      }
                      onChange={() => handleToggleAllCollects()}
                    />
                  }
                  label="Marcar/Desmarcar Cobros"
                />
              </Grid>
              <Divider sx={{ margin: 0 }} />

              <Grid item xs={12}></Grid>
              {collectsOffice && collectsOffice.length > 0 ? (
                collectsOffice.map((collect: Collect) => (
                  <Grid item xs={6} sm={12} md={6} lg={6} key={collect.id}>
                    <Grid container rowSpacing={1} columnSpacing={1} spacing={isMobile ? 2 : 0} sx={{ mb: isMobile ? 2 : 0 }}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControlLabel
                          control={<Checkbox checked={collectCheckbox[collect.id] || false} onChange={() => handleCheckboxChange(collect.id)} />}
                          label={collect.name}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={6} container alignItems="center" justifyContent="flex-start">
                        <Box display="flex" gap={1}>
                          <Button
                            component="span"
                            sx={{ display: 'none' }}
                          />
                          {cajaMode === 'cobro' ? (
                            <PermissionButton
                              allowed={canAdjustBox}
                              deniedTooltip="Sin permiso para ajustar caja"
                              tooltip="Ajustar caja"
                              variant="contained"
                              color="primary"
                              sx={{
                                marginLeft: '0px',
                                width: '30px',
                                padding: '5px',
                                minWidth: 'unset',
                                boxSizing: 'border-box',
                              }}
                              onClick={() => OpenModalBox(collect)}
                            >
                              <PointOfSaleIcon fontSize="small" />
                            </PermissionButton>
                          ) : null}
                          <PermissionButton
                            allowed={cajaMode === 'seguro' ? canManageInsuranceBox : canRegisterExpenses}
                            deniedTooltip={cajaMode === 'seguro' ? 'Sin permiso para gestionar caja seguro' : 'Sin permiso para registrar gastos'}
                            tooltip={cajaMode === 'seguro' ? 'Registrar gasto de seguro' : 'Registrar gastos'}
                            variant="contained"
                            color="primary"
                            disabled={cajaMode === 'seguro' && !getBoxByMode(collect, 'seguro')}
                            sx={{
                              marginLeft: '0px',
                              width: '30px',
                              padding: '5px',
                              minWidth: 'unset',
                              boxSizing: 'border-box',
                            }}
                            onClick={() => handleOpenModal(collect)}
                          >
                            <InsertChartIcon fontSize="small" />
                          </PermissionButton>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{
                              marginLeft: '0px',
                              width: '30px', //
                              padding: '5px', //
                              minWidth: 'unset', //
                              boxSizing: 'border-box', //
                            }}
                            onClick={() => handleClearExpenses(collect.id)}
                          >
                            <CleaningServicesRoundedIcon fontSize="small" />
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} container alignItems="left" justifyContent="flex-start" >
                        <TextField
                          fullWidth
                          label="Valor"
                          size="small"
                          placeholder="1000"
                          value={
                            collectCheckbox[collect.id]
                              ? collectExpenses[collect.id]
                                ? Object.values(collectExpenses[collect.id]).reduce((a, b) => a + b.value, 0)
                                : "0"
                              : "0"
                          }
                          inputProps={{ maxLength: 20, min: 0 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField fullWidth label='Disponible' size="small" value={getBoxByMode(collect, cajaMode)?.balance ?? '0'} />
                      </Grid>
                    </Grid>
                  </Grid>

                ))
              ) : null}
            </Grid>
          </CardContent>
          <Divider sx={{ margin: 0 }} />
          <CardActions>
            <Button size='small' type='submit' sx={{ mr: 2 }} variant='contained' onClick={submit}>
              Guardar
            </Button>
            <Link to='/prestamos/gastos/list'>
              <Button size='small' color='secondary' variant='outlined'>
                Cancelar
              </Button>
            </Link>
          </CardActions>
        </form>
      </Card>
      <CollectDetails
        open={modalOpen}
        handleClose={handleCloseModal}
        collectsOffice={collectsOffice}
        collectCheckbox={collectCheckbox}
        handleCheckboxChange={handleCheckboxChange}
        collect={selectedCollect}
        expenses={
          selectedCollect
            ? collectExpenses[selectedCollect.id]
              ? expenses.map((exp) => ({
                ...exp,
                value: collectExpenses[selectedCollect.id][exp.id]?.value || 0,
              }))
              : expenses
            : []
        }
        setValue={(value, expenseId) => {
          if (selectedCollect) {
            const typeOperationId = expenses.find(exp => exp.id === expenseId)?.type_operation?.id || 2;
            const targetBoxId = getBoxByMode(selectedCollect, cajaMode)?.id;
            if (targetBoxId) {
              handleSetExpenseValue(selectedCollect.id, expenseId, value, targetBoxId, typeOperationId);
            }
          }
        }}
        isEditable={selectedCollect ? collectCheckbox[selectedCollect.id] || false : false}
      />
      <CollectBox
        open={modalOpenBox}
        handleClose={CloseModalBox}
        collect={selectedCollect}
        expenses={selectedCollect ? (collectExpenses[selectedCollect.id] ? expensesBox.map(exp => ({ ...exp, value: collectExpenses[selectedCollect.id][exp.id]?.value || 0 })) : expensesBox) : []}
        selectedExpenses={selectedCollect ? selectedExpensesByCollect[selectedCollect.id] || [] : []}
        onSelectedExpensesChange={(expenseIds) => {
          if (selectedCollect) {
            handleSelectedExpensesChange(selectedCollect.id, expenseIds);
          }
        }}
        setValue={(value, expenseId) => {
          if (selectedCollect) {
            const typeOperationId = expensesBox.find(exp => exp.id === expenseId)?.type_operation?.id || 2;
            const targetBoxId = getBoxByMode(selectedCollect, 'cobro')?.id;
            if (targetBoxId) {
              SetExpenseValueBox(selectedCollect.id, expenseId, value, targetBoxId, typeOperationId);
            }
          }
        }}
        isEditable={selectedCollect ? collectCheckbox[selectedCollect.id] || false : false}
      />
    </HeaderResponsive>
  );
};

export default GastosAdd;
